(function () {
  const SELECTOR = '.pgv-lazy-image[data-src]';
  const LOADED_ATTR = 'data-lazy-loaded';

  function loadImage(img) {
    if (!img || img.getAttribute(LOADED_ATTR) === 'true') return;
    const src = img.getAttribute('data-src');
    if (!src) return;
    img.setAttribute('src', src);
    img.setAttribute(LOADED_ATTR, 'true');
    img.removeAttribute('data-src');
  }

  function isInViewport(img) {
    const rect = img.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    const margin = 120;
    return rect.top < window.innerHeight + margin && rect.bottom > -margin;
  }

  function initLazyImages(root) {
    const scope = root || document;
    const images = scope.querySelectorAll(SELECTOR);
    if (!images.length) return;

    if (!('IntersectionObserver' in window)) {
      images.forEach(loadImage);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadImage(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '120px 0px',
        threshold: 0.01,
      }
    );

    images.forEach((img) => {
      if (isInViewport(img)) {
        loadImage(img);
        return;
      }
      observer.observe(img);
    });
  }

  function observeProductGrid() {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid || grid.dataset.pgvGridObserved === 'true') return;
    grid.dataset.pgvGridObserved = 'true';

    const gridObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          initLazyImages(node);
        });
      });
    });

    gridObserver.observe(grid, { childList: true, subtree: true });
  }

  function initPgv(root) {
    initLazyImages(root || document);
    observeProductGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPgv(document);
    });
  } else {
    initPgv(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPgv(event.target);
    initPgvSliders(event.target);
  });

  function initPgvSliders(root) {
    const scope = root || document;
    scope.querySelectorAll('product-slider').forEach(function (slider) {
      if (slider.dataset.pgvSliderInit === 'true') return;

      const bindSlider = function () {
        if (!slider.sliderInstance || !slider.sliderInstance.slider) return false;
        slider.sliderInstance.slider.on('slideChange', function () {
          initLazyImages(slider);
        });
        return true;
      };

      if (bindSlider()) {
        slider.dataset.pgvSliderInit = 'true';
        return;
      }

      const observer = new MutationObserver(function () {
        if (bindSlider()) {
          slider.dataset.pgvSliderInit = 'true';
          observer.disconnect();
        }
      });
      observer.observe(slider, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPgvSliders(document);
    });
  } else {
    initPgvSliders(document);
  }

  function scrollActivePgvOption(modal) {
    const activeOption = modal.querySelector('.pgv-modal__grid .pgv-option.is-active');
    if (!activeOption) return;

    activeOption.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    initLazyImages(modal);
  }

  function initPgvModals(root) {
    const scope = root || document;
    scope.querySelectorAll('.pgv-modal').forEach(function (modal) {
      if (modal.dataset.pgvInit === 'true') return;
      modal.dataset.pgvInit = 'true';

      modal.addEventListener('modal:handleAfterShow', function () {
        scrollActivePgvOption(modal);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPgvModals(document);
    });
  } else {
    initPgvModals(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPgvModals(event.target);
  });
})();
